interface PersonIconProps extends React.ComponentPropsWithoutRef<'svg'> {
  color?: string;
}

export function PersonIcon({ color = 'currentColor', ...svgProps }: PersonIconProps) {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        d="M19.0993 17.3775L19.2743 16.9091C19.1549 16.8645 19.0229 16.8672 18.9054 16.9166L19.0993 17.3775ZM23 28V28.5C23.2761 28.5 23.5 28.2761 23.5 28H23ZM9 28H8.5C8.5 28.2761 8.72386 28.5 9 28.5V28ZM12.9007 17.3775L13.0946 16.9166C12.9771 16.8672 12.8451 16.8645 12.7257 16.9091L12.9007 17.3775ZM16 15.5C19.0376 15.5 21.5 13.0376 21.5 10H20.5C20.5 12.4853 18.4853 14.5 16 14.5V15.5ZM10.5 10C10.5 13.0376 12.9624 15.5 16 15.5V14.5C13.5147 14.5 11.5 12.4853 11.5 10H10.5ZM16 4.5C12.9624 4.5 10.5 6.96243 10.5 10H11.5C11.5 7.51472 13.5147 5.5 16 5.5V4.5ZM21.5 10C21.5 6.96243 19.0376 4.5 16 4.5V5.5C18.4853 5.5 20.5 7.51472 20.5 10H21.5ZM18.9054 16.9166C18.0125 17.2922 17.0312 17.5 16 17.5V18.5C17.1667 18.5 18.2797 18.2647 19.2932 17.8384L18.9054 16.9166ZM23.5 23C23.5 20.2094 21.7417 17.8308 19.2743 16.9091L18.9243 17.8459C21.0136 18.6263 22.5 20.6402 22.5 23H23.5ZM23.5 28V23H22.5V28H23.5ZM9 28.5H23V27.5H9V28.5ZM8.5 23V28H9.5V23H8.5ZM12.7257 16.9091C10.2583 17.8308 8.5 20.2094 8.5 23H9.5C9.5 20.6402 10.9864 18.6263 13.0757 17.8459L12.7257 16.9091ZM16 17.5C14.9688 17.5 13.9875 17.2922 13.0946 16.9166L12.7068 17.8384C13.7203 18.2647 14.8333 18.5 16 18.5V17.5Z"
        fill={color}
      />
    </svg>
  );
}
